module.exports = __webpack_public_path__ + "assets/pin-rejected.19048023.svg";